import { startCase } from "lodash";

export const isStringEqual = (a: string, b: string) => {
    return a.toLowerCase() === b.toLowerCase();
};

export const titleCase = (str: string) => {
    return startCase(str.toLowerCase());
};
